<div class="modal notification-modal credits-modal" tabindex="-1" role="dialog" *ngIf="activeModal">
    <div class="modal-dialog" role="document">

        <div id="selection-credits-content" class="modal-content credits-selection" *ngIf="isReadingView()">
            <button type="button" class="btn-black-close close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"></button>
            <div class="modal-body py-2 px-2">
                <div class="row credits-content">
                    <div class="credits-image-block col-xs-2">
                        <div class="credits-image"></div>
                    </div>
                    <div class="col-xs-10 pl-0 credits-intro">Credits and Acknowledgements for:</div>
                    <div class="col-xs-10 pl-0 credits-selection-title">{{titleCredits}}</div>
                </div>
                <h3 class="mt-1 title">Reading Credits</h3>
                <div class="credits-contents-area mb-1">

                    <div class="credits-section credits-section-row">
                        <span class="credits-header">Content</span>
                        <div class="credits-items" *ngFor="let credit of credits">
                            <span class="credits-info">{{credit.description}}</span>
                        </div>
                    </div>

                    <div class="credits-section credits-section-row">
                        <span class="credits-header">Credit</span>
                        <div class="credits-items" *ngFor="let credit of credits">
                            <span class="credits-info">{{credit.attribution}}</span>
                        </div>
                    </div>

                </div>

                <h3 class="title">Glossary Credits</h3>
                <div class="credits-contents-area mb-1">

                    <div class="credits-section credits-section-row">
                        <span class="credits-header">Word</span>
                        <div class="credits-items" *ngFor="let imageCredit of imageCredits">
                            <span class="credits-info">{{imageCredit.word}}</span>
                        </div>
                    </div>

                    <div class="credits-section credits-section-row">
                        <span class="credits-header">Image Description</span>
                        <div class="credits-items" *ngFor="let imageCredit of imageCredits">
                            <span class="credits-info">{{imageCredit.description}}</span>
                        </div>
                    </div>

                    <div class="credits-section credits-section-row">
                        <span class="credits-header">Credit</span>
                        <div class="credits-items" *ngFor="let imageCredit of imageCredits">
                            <span class="credits-info">{{imageCredit.attribution}}</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
<div class="modal-backdrop fade in" *ngIf="activeModal"></div>
